import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

import { format, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const timeZone = "UTC";

export function formatDate(isoString: string, formatStr: string = "yyyy-MM-dd") {
  const zonedDate = toZonedTime(parseISO(isoString), timeZone);
  return format(zonedDate, formatStr);
}
